import { render, staticRenderFns } from "./workTypeArchive.vue?vue&type=template&id=0afef98c&"
import script from "./workTypeArchive.vue?vue&type=script&lang=js&"
export * from "./workTypeArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports